import React from "react";


import {
    Col, Row
} from "react-bootstrap";


import {
    SvgIconComponent
} from "@Components/Elements";


import "./index.scss";


import IconSuccessMd from "./@Icons/icon-success-md.svg";
import IconInfoMd from "./@Icons/icon-info-md.svg";
import IconWarningMd from "./@Icons/icon-warning-md.svg";
import IconErrorMd from "./@Icons/icon-error-md.svg";


type DashboardStateCardType =
    'success' | 'warning' | 'info' | 'error'
;

interface DashboardStateCardElementComponentProps {
    cardType: DashboardStateCardType;
    cardTitle: string;
    cardDescription: string;
}

type CardElementIconsType = {
    [key in DashboardStateCardType]: string;
};

const CardElementIcons: CardElementIconsType = {
    'success': IconSuccessMd,
    'info': IconInfoMd,
    'warning': IconWarningMd,
    'error': IconErrorMd
};


export const DashboardStateCardElementComponent:React.FC<DashboardStateCardElementComponentProps> = ({
    cardType, cardTitle, cardDescription
}) => {

    const ElementIcon = CardElementIcons[cardType];

    return (
        <Col xs={12} className={`dashboard-state-card-element-component ${cardType}-card-type`}>
            <Row className={'dashboard-state-card-element-component__content'}>
                <Col xs={12} className={'dashboard-state-card-element-component__card-header'}>
                    <SvgIconComponent iconSource={ElementIcon} className={'card-icon-element'} />
                    <span className={'card-title-element'}>{cardTitle}</span>
                </Col>
                <Col xs={12} className={'dashboard-state-card-element-component__card-description'}>
                    <span className={'card-description-element'}>{cardDescription}</span>
                </Col>
            </Row>
        </Col>
    );

};


export default DashboardStateCardElementComponent;
